module.exports = __webpack_public_path__ + "static/3-91d8e5f021ea50cd023a8f96e2d0aad1.png";